import React from "react";

const variants = {
  "success": "switch__slider--success",
  "warning": "switch__slider--warning",
  "error": "switch__slider--error",
}

const SwitchCheckbox = (props) => {
  const darkSwitch = props.darkSwitch ? "switch__slider--dark" : "";

  const classes = `switch__slider switch__slider--round ${variants[props.variant]} ${darkSwitch}`.trim();

  return (
    <label className="switch">
      <input type="checkbox" className="switch__checkbox"
        onChange={props.onChange} checked={props.checked} defaultChecked={props.initialState} disabled={props.disabled} />
      <span className={classes} />
    </label>
  );
}

SwitchCheckbox.defaultProps = {
  initialState: false
}

export default SwitchCheckbox;